import React, { useMemo } from "react";

import { useLoading } from "app/custom-hooks/loadingHook";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

import { TrafficAndEngagementHighLevelDataInner } from "../../TrafficAndEngagementHighLevelData";
import type { IBaseSingleRequestParams } from "../../types";

import { TotalVisitsGrowthBoxContainer } from "./StyledComponents";
import { TotalVisitsGrowth } from "./TotalVisitsGrowth";

export const TrafficComparePOPModeContainer: React.FunctionComponent<any> = (props) => {
    const { showGAApprovedData, apiParams } = props;
    const { webSource, country, key, isWindow, isWWW, to, from, compareFrom, compareTo } = apiParams;
    const apiParamsObj = useMemo(() => {
        return {
            country,
            from,
            to,
            includeSubDomains: !isWWW,
            isWindow,
            keys: key,
            timeGranularity: "Monthly",
            webSource,
            compareFrom,
            compareTo,
            ShouldGetVerifiedData: showGAApprovedData,
        };
    }, [country, from, to, isWWW, isWindow, key, webSource, compareFrom, compareTo, showGAApprovedData]);

    const services = useMemo(
        () => ({
            websiteAnalysisApiService: new WebsiteAnalysisApiService(),
        }),
        [],
    );

    const excelUrl = useMemo(() => {
        const excelFileName = `EngagementVisits - ${key} - (${country}) - (${from}) - (${to})`;
        return services.websiteAnalysisApiService.getTrafficGrowthComparisonGraphExcelUrl({
            ...apiParamsObj,
            FileName: excelFileName,
        } as IBaseSingleRequestParams);
    }, [
        services.websiteAnalysisApiService,
        country,
        from,
        to,
        isWWW,
        isWindow,
        key,
        webSource,
        compareFrom,
        compareTo,
        showGAApprovedData,
    ]);

    const [engagementVisitsTableData, engagementVisitsTableDataOps] = useLoading();
    React.useEffect(() => {
        engagementVisitsTableDataOps.load(() =>
            services.websiteAnalysisApiService.getEngagementVisitsTableData({
                ...apiParamsObj,
            }),
        );
    }, [
        services.websiteAnalysisApiService,
        country,
        from,
        to,
        isWWW,
        isWindow,
        key,
        webSource,
        compareFrom,
        compareTo,
        showGAApprovedData,
    ]);

    const isEngagementVisitsTableDataLoading = [useLoading.STATES.INIT, useLoading.STATES.LOADING].includes(
        engagementVisitsTableData.state,
    );

    return (
        <>
            <TotalVisitsGrowthBoxContainer>
                <TotalVisitsGrowth
                    data={engagementVisitsTableData}
                    keys={key}
                    isLoading={isEngagementVisitsTableDataLoading}
                    excelUrl={excelUrl}
                    showGAApprovedData={showGAApprovedData}
                />
            </TotalVisitsGrowthBoxContainer>
            <TrafficAndEngagementHighLevelDataInner {...props} />
        </>
    );
};
